import { render, staticRenderFns } from "./BIBidsList.vue?vue&type=template&id=039d60b4"
import script from "./BIBidsList.vue?vue&type=script&lang=js"
export * from "./BIBidsList.vue?vue&type=script&lang=js"
import style0 from "./BIBidsList.vue?vue&type=style&index=0&id=039d60b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports